import React, { Component } from 'react';

import MediaIcon from '../components/MediaIcon';

class ParticipantItem extends Component {

    render() {
        const {item} = this.props;

        return (
            <MediaIcon icon="user">
                <p>
                    <strong>{item["PERSON:VORNAME"]} {item["PERSON:NACHNAME"]}</strong><br />
                    {item["PERSON_ADRESSE:STRASSE:1"]}<br />
                    {item["PERSON_ADRESSE:PLZ:1"]} {item["PERSON_ADRESSE:ORT:1"]}
                </p>
                {item["DV_MAIN"] && (
                    <p>
                        <strong>Dateien</strong> <br />
                        {Object.entries(item["DV_MAIN"]).map(([key, value]) => (
                            <div>{key}</div>
                        ))}
                    </p>
                )}
            </MediaIcon>
        );
    }
}

export default ParticipantItem;
